import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { InputField } from "../components/form";
import { SmallSpinner } from "../components/loaders";

import { updateCurrentPassword } from "../actions/profileActions";
import { showPopUp, hideModal } from "../utils/domUtils";

interface ComponentProps {
  modal_id: string;
  updateCurrentPassword: Function;
}

class UpdatePasswordModal extends React.Component<ComponentProps, {}> {
  state = {
    current_password: "",
    new_password: "",
    errors: {},
  };

  static getDerivedStateFromProps(nextProps) {
    let newState = {
      errors: null,
      changed: false,
    };
    if (nextProps.errors) {
      newState.errors = nextProps.errors;
      newState.changed = true;
    }
    return newState.changed ? newState : null;
  }

  onChangeTextInput = (e) => this.setState({ [e.target.name]: e.target.value });

  isLoading(): boolean {
    // @ts-ignore
    return this.props.profile.loading === true;
  }

  onUpdatePassword = () => {
    const { current_password, new_password } = this.state;
    this.props.updateCurrentPassword(
      {
        current_password,
        new_password,
      },
      (success) => {
        if (success) {
          showPopUp("Clave actualizada exitosamente!", "");
          this.setState({
            current_password: "",
            new_password: "",
          });
          hideModal(this.props.modal_id);
        }
      }
    );
  };

  getForm = () => {
    const { current_password, new_password, errors } = this.state;
    const loading = this.isLoading();
    return (
      <>
        <InputField
          id="current_password"
          value={current_password}
          label="Clave actual"
          type="password"
          onChange={this.onChangeTextInput}
          error={errors}
          disabled={loading}
        />

        <InputField
          id="new_password"
          value={new_password}
          label="Nueva clave"
          type="password"
          onChange={this.onChangeTextInput}
          error={errors}
          disabled={loading}
        />

        {loading && <SmallSpinner center={true} />}
      </>
    );
  };

  render() {
    // @ts-ignore
    const modal_id = this.props.modal_id;
    return (
      <div className="modal" id={modal_id}>
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Actualizar clave</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">{this.getForm()}</div>
            <div className="modal-footer">
              <div className="flex-2-separated">
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={this.onUpdatePassword}
                >
                  Actualizar
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  data-dismiss="modal"
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// @ts-ignore
UpdatePasswordModal.propTypes = {
  profile: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  modal_id: PropTypes.string.isRequired,
  updateCurrentPassword: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  profile: state.profile,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  updateCurrentPassword,
})(UpdatePasswordModal);
